import {
  Button,
  ErrorSummary,
  Form,
  FormRadioGroup,
  HorizontalRule,
  InPageAlert,
  SectionPage,
} from '@snsw/react-component-library';
import React, { useEffect, useState } from 'react';
import ScrollToTop from '../../../shared/utils/scrollToTop';
import { useNavigate } from 'react-router-dom';
import { Callout } from '@snsw/react-component-library';
import styles from './PlantDesignWhatYouNeed.module.scss';
import { radioOptionsYesNo } from 'shared/constants/constants';
import { isEmpty, validate, validateExt } from 'shared/utils/Validation';
import { DownloadButton } from 'shared/components/downloadButton/DownloadButton';
import { PagePath } from 'shared/constants/pagePath';
import { store } from 'shared/redux/configureStore';
import { clearForm, clearPlantDesignForm, storeRedirect } from 'plantItemNew/redux/slices/formSlice';
import { clearApplication } from 'shared/redux/applicationSlice';
import { clearPlantDesignReferenceData } from 'plantDesign/redux/plantDesignReferenceDataSlice';
import { PlantDesignConstants } from 'plantDesign/constants/plantDesignConstants';
import { UserPasswordlessManager } from 'shared/oidc/passwordLessUserManager';
import { useSelector } from 'react-redux';

export const PlantDesignWhatYouNeed = () => {
  ScrollToTop();
  const navigate = useNavigate();

  const [haveAllDocuments, setHaveAllDocuments] = useState('');
  const haveAllDocumentsOptions = radioOptionsYesNo;

  const [errors, setErrors] = useState({});
  const [errorSummary, setErrorSummary] = useState([]);
  const [showErrors, setShowErrors] = useState(false);

  const passwordlessOidc = useSelector((state) => state.passwordlessOidc);

  useEffect(() => {
    store.dispatch(clearApplication());
    store.dispatch(clearForm());
    store.dispatch(clearPlantDesignForm());
    store.dispatch(clearPlantDesignReferenceData());

    if (passwordlessOidc.user?.access_token) {
      store.dispatch(storeRedirect(PagePath.plantDesignWhatYouNeed));
      UserPasswordlessManager.instance().signoutRedirect();
    }
  }, []);

  useEffect(() => {
    if (showErrors) validate(validators, setErrors);
  }, [haveAllDocuments]);

  const validators = [
    {
      fieldName: 'haveAllDocuments',
      fieldValue: haveAllDocuments,
      isValid: (v) => !isEmpty(v),
      errorMessage: () => 'Do you have all your documents?',
    },
  ];

  const onStartClick = () => {
    setShowErrors(true);
    const isValid = validateExt(validators, setErrors, setErrorSummary);
    if (isValid) {
      navigate(PagePath.plantDesignApplicantDetails);
    }
  };

  return (
    <>
      {!!haveAllDocuments || (
        <ErrorSummary singularTitle="You must select if you have all your documents" errors={errorSummary} />
      )}

      <SectionPage>
        <Callout title="Prepare your documents before you apply online">
          <ol className={styles.calloutList}>
            <li>
              Download and complete the{' '}
              <a href={PlantDesignConstants.designerAndVerifierStatementUrl} target="_blank" rel="noreferrer">
                Designer and Design verifier statement
              </a>
              .
            </li>
            <li>Get the statement signed.</li>
            <li>Check all your documents, including the statement and any drawings, are ready to upload.</li>
          </ol>
        </Callout>
      </SectionPage>

      <SectionPage className={styles.documentCheck}>
        <Form>
          <FormRadioGroup
            id="have-all-documents"
            name="haveAllDocuments"
            vertical={false}
            legend="Do you have all your documents?"
            helpMessage="You cannot apply without a completed Designer and Design verifier statement."
            options={haveAllDocumentsOptions}
            onChange={setHaveAllDocuments}
            value={haveAllDocuments}
            errorMessage="Please select if you have all your documents ready"
            hasError={errors?.haveAllDocuments?.invalid}
          />
        </Form>
      </SectionPage>

      {haveAllDocuments === 'no' && (
        <>
          <InPageAlert
            variant="warning"
            title="You need a completed Designer and Design verifier statement to complete this online application."
            headingLevel="h5"
            className={styles.documentWarning}
          />
          <DownloadButton
            href={PlantDesignConstants.designerAndVerifierStatementUrl}
            label="Designer and Design verifier statement"
          />
        </>
      )}

      <SectionPage>
        <HorizontalRule />
        <div style={{ marginTop: 64, paddingLeft: 8 }}>
          <Button onClick={() => onStartClick()}>Continue</Button>
        </div>
      </SectionPage>
    </>
  );
};
